import styled, { css } from 'styled-components';

import { fadeIn } from 'styles/animations';

export const PrivacyStatementContainer = styled.p<PrivacyStatementContainerProps>`
  font-weight: 600;
  width: 100%;
  border-radius: 4px;
  text-align: center;
  animation: ${fadeIn} 300ms ease-out;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.blue.dark};
  margin: auto 0 24px;

  > a {
    color: ${({ theme }) => theme.colors.blue.dark};
  }

  ${({ noFooter }) => noFooter && css`
    position: absolute;
    bottom: 24px;
    left: 0;
    margin: 0;
  `}
`;

type PrivacyStatementContainerProps = {
  noFooter?: boolean;
};
